import React, { useMemo } from "react";

import { PrintButton } from "../../component/button";
import { useFormState } from "react-final-form";

const PrintWrapperButton = ({
  disabled = (props) =>
    ["draft", "integrations_requested"].indexOf(
      props?.record?.transaction?.state
    ) === -1,
  ...props
}) => {
  const isDisabled = useMemo(
    () => (typeof disabled === "function" ? disabled(props) : disabled),
    [disabled, props]
  );
  const { dirty } = useFormState({ subscription: { dirty: true } });
  return <PrintButton {...props} disabled={isDisabled || dirty} />;
};
export default PrintWrapperButton;
